"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var LossLimitReached_1 = __importDefault(require("./LossLimitReached"));
var BetLimitReached_1 = __importDefault(require("./BetLimitReached"));
var SessionLimitReached_1 = __importDefault(require("./SessionLimitReached"));
var CoolingOffLimitActive_1 = __importDefault(require("./CoolingOffLimitActive"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var ReachedLimitsInGame = function () {
    var coolingOffLimit = (0, swr_hooks_1.useCoolingOffLimit)().data;
    if (coolingOffLimit)
        return react_1.default.createElement(CoolingOffLimitActive_1.default, null);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LossLimitReached_1.default, null),
        react_1.default.createElement(BetLimitReached_1.default, null),
        react_1.default.createElement(SessionLimitReached_1.default, null)));
};
exports.default = ReachedLimitsInGame;
